/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddMortalityModelAssignment} from '../bioplanModels';
// @ts-ignore
import type {EditMortalityModelAssignment} from '../bioplanModels';
// @ts-ignore
import type {MortalityModelAssignment} from '../bioplanModels';
/**
 * MortalityModelAssignmentApi - axios parameter creator
 * @export
 */
export const MortalityModelAssignmentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsAssignmentIdDelete: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('mortalityModelAssignmentsAssignmentIdDelete', 'assignmentId', assignmentId);
      const localVarPath = `/mortalityModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsAssignmentIdGet: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('mortalityModelAssignmentsAssignmentIdGet', 'assignmentId', assignmentId);
      const localVarPath = `/mortalityModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assignmentId
     * @param {EditMortalityModelAssignment} editMortalityModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsAssignmentIdPut: async (
      assignmentId: string,
      editMortalityModelAssignment: EditMortalityModelAssignment,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('mortalityModelAssignmentsAssignmentIdPut', 'assignmentId', assignmentId);
      // verify required parameter 'editMortalityModelAssignment' is not null or undefined
      assertParamExists(
        'mortalityModelAssignmentsAssignmentIdPut',
        'editMortalityModelAssignment',
        editMortalityModelAssignment,
      );
      const localVarPath = `/mortalityModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        editMortalityModelAssignment,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('mortalityModelAssignmentsGet', 'planId', planId);
      const localVarPath = `/mortalityModelAssignments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddMortalityModelAssignment} addMortalityModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsPost: async (
      addMortalityModelAssignment: AddMortalityModelAssignment,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addMortalityModelAssignment' is not null or undefined
      assertParamExists('mortalityModelAssignmentsPost', 'addMortalityModelAssignment', addMortalityModelAssignment);
      const localVarPath = `/mortalityModelAssignments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        addMortalityModelAssignment,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MortalityModelAssignmentApi - functional programming interface
 * @export
 */
export const MortalityModelAssignmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MortalityModelAssignmentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelAssignmentsAssignmentIdDelete(
      assignmentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelAssignmentsAssignmentIdDelete(
        assignmentId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelAssignmentApi.mortalityModelAssignmentsAssignmentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelAssignmentsAssignmentIdGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelAssignmentsAssignmentIdGet(
        assignmentId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelAssignmentApi.mortalityModelAssignmentsAssignmentIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assignmentId
     * @param {EditMortalityModelAssignment} editMortalityModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelAssignmentsAssignmentIdPut(
      assignmentId: string,
      editMortalityModelAssignment: EditMortalityModelAssignment,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelAssignmentsAssignmentIdPut(
        assignmentId,
        editMortalityModelAssignment,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelAssignmentApi.mortalityModelAssignmentsAssignmentIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelAssignmentsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MortalityModelAssignment>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelAssignmentsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelAssignmentApi.mortalityModelAssignmentsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AddMortalityModelAssignment} addMortalityModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelAssignmentsPost(
      addMortalityModelAssignment: AddMortalityModelAssignment,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelAssignmentsPost(
        addMortalityModelAssignment,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelAssignmentApi.mortalityModelAssignmentsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MortalityModelAssignmentApi - factory interface
 * @export
 */
export const MortalityModelAssignmentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MortalityModelAssignmentApiFp(configuration);
  return {
    /**
     *
     * @param {MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsAssignmentIdDelete(
      requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .mortalityModelAssignmentsAssignmentIdDelete(requestParameters.assignmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsAssignmentIdGet(
      requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModelAssignment> {
      return localVarFp
        .mortalityModelAssignmentsAssignmentIdGet(requestParameters.assignmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsAssignmentIdPut(
      requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModelAssignment> {
      return localVarFp
        .mortalityModelAssignmentsAssignmentIdPut(
          requestParameters.assignmentId,
          requestParameters.editMortalityModelAssignment,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MortalityModelAssignmentApiMortalityModelAssignmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsGet(
      requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MortalityModelAssignment>> {
      return localVarFp
        .mortalityModelAssignmentsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MortalityModelAssignmentApiMortalityModelAssignmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelAssignmentsPost(
      requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModelAssignment> {
      return localVarFp
        .mortalityModelAssignmentsPost(requestParameters.addMortalityModelAssignment, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for mortalityModelAssignmentsAssignmentIdDelete operation in MortalityModelAssignmentApi.
 * @export
 * @interface MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDeleteRequest
 */
export interface MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDelete
   */
  readonly assignmentId: string;
}

/**
 * Request parameters for mortalityModelAssignmentsAssignmentIdGet operation in MortalityModelAssignmentApi.
 * @export
 * @interface MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGetRequest
 */
export interface MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGet
   */
  readonly assignmentId: string;
}

/**
 * Request parameters for mortalityModelAssignmentsAssignmentIdPut operation in MortalityModelAssignmentApi.
 * @export
 * @interface MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPutRequest
 */
export interface MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPut
   */
  readonly assignmentId: string;

  /**
   *
   * @type {EditMortalityModelAssignment}
   * @memberof MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPut
   */
  readonly editMortalityModelAssignment: EditMortalityModelAssignment;
}

/**
 * Request parameters for mortalityModelAssignmentsGet operation in MortalityModelAssignmentApi.
 * @export
 * @interface MortalityModelAssignmentApiMortalityModelAssignmentsGetRequest
 */
export interface MortalityModelAssignmentApiMortalityModelAssignmentsGetRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelAssignmentApiMortalityModelAssignmentsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for mortalityModelAssignmentsPost operation in MortalityModelAssignmentApi.
 * @export
 * @interface MortalityModelAssignmentApiMortalityModelAssignmentsPostRequest
 */
export interface MortalityModelAssignmentApiMortalityModelAssignmentsPostRequest {
  /**
   *
   * @type {AddMortalityModelAssignment}
   * @memberof MortalityModelAssignmentApiMortalityModelAssignmentsPost
   */
  readonly addMortalityModelAssignment: AddMortalityModelAssignment;
}

/**
 * MortalityModelAssignmentApi - object-oriented interface
 * @export
 * @class MortalityModelAssignmentApi
 * @extends {BaseAPI}
 */
export class MortalityModelAssignmentApi extends BaseAPI {
  /**
   *
   * @param {MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelAssignmentApi
   */
  public mortalityModelAssignmentsAssignmentIdDelete(
    requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelAssignmentApiFp(this.configuration)
      .mortalityModelAssignmentsAssignmentIdDelete(requestParameters.assignmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelAssignmentApi
   */
  public mortalityModelAssignmentsAssignmentIdGet(
    requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelAssignmentApiFp(this.configuration)
      .mortalityModelAssignmentsAssignmentIdGet(requestParameters.assignmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelAssignmentApi
   */
  public mortalityModelAssignmentsAssignmentIdPut(
    requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsAssignmentIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelAssignmentApiFp(this.configuration)
      .mortalityModelAssignmentsAssignmentIdPut(
        requestParameters.assignmentId,
        requestParameters.editMortalityModelAssignment,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MortalityModelAssignmentApiMortalityModelAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelAssignmentApi
   */
  public mortalityModelAssignmentsGet(
    requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelAssignmentApiFp(this.configuration)
      .mortalityModelAssignmentsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MortalityModelAssignmentApiMortalityModelAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelAssignmentApi
   */
  public mortalityModelAssignmentsPost(
    requestParameters: MortalityModelAssignmentApiMortalityModelAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelAssignmentApiFp(this.configuration)
      .mortalityModelAssignmentsPost(requestParameters.addMortalityModelAssignment, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
